import React, { CSSProperties, useState } from "react";
import { useTheme } from "styled-components";
import { IconType } from "@shared/types";
import { ICON_TYPES } from "@shared/common/constants";
import Avatar from "antd/es/avatar";
import { getAssetIcon, getExchangeIcon } from "common/Icons/utils.ts";

interface ExchangeAvatarProps {
  text: string;
  style?: CSSProperties;
  size?: number;
  iconType?: IconType;
  iconSize?: number;
}

const ExchangeAvatar: React.FC<ExchangeAvatarProps> = ({
  text,
  style,
  iconType = ICON_TYPES.EXCHANGE,
  iconSize,
  ...props
}) => {
  const appTheme = useTheme();
  const [error, setError] = useState(false);

  const avatarStyle = {
    background: appTheme.colors.cardBgColor,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    ...style,
  };
  if (error) {
    avatarStyle.background = appTheme.colors.primaryBlue;
  } else {
    avatarStyle.border = "1.5px solid rgb(137, 146, 163, 0.3)";
  }

  const getImageFilters = () => {
    if (appTheme.isDarkMode && text.toLowerCase().includes("okx")) {
      return "invert(100%)";
    }
  };

  const contractsStyle =
    text?.toLowerCase() === "contracts"
      ? {
          width: "auto",
          height: iconSize ? iconSize - 4 : "70%",
          marginLeft: 2,
        }
      : {};
  const icon = error ? (
    text.charAt(0)
  ) : (
    <img
      src={
        iconType === ICON_TYPES.EXCHANGE
          ? getExchangeIcon(text)
          : getAssetIcon(text)
      }
      onError={() => setError(true)}
      alt={text}
      style={{
        width: iconSize,
        height: iconSize,
        filter: getImageFilters(),
        ...contractsStyle,
      }}
    />
  );

  return <Avatar style={avatarStyle} icon={icon} {...props} />;
};

export default ExchangeAvatar;
